import { render, staticRenderFns } from "./ContactTableMixin.vue?vue&type=template&id=023187e8&"
import script from "./ContactTableMixin.vue?vue&type=script&lang=js&"
export * from "./ContactTableMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports